import {call, put, takeLatest} from "redux-saga/effects";
import {IBaseRespone} from "../../../model/respone/IBaseRespone";
import {rootActions} from "../../actions/rootActions";
import {IBienLaiThuCreateRequest} from "../../../model/request/bien-lai/IBienLaiThuCreateRequest";
import {IBienLaiThuUpdateRequest} from "../../../model/request/bien-lai/IBienLaiThuUpdateRequest";
import {bienLaiThuApi} from "../../../api/bien-lai/bienLaiThuApi";
import {thiSinhApi} from "../../../api/category/thiSinhApi";
import {
    eThuPhiTuyenSinhActionIds,
    IThuPhiTuyenSinhActionTypes,
} from "../../action-types/thu-phi-tuyen-sinh/IThuPhiTuyenSinhActionTypes";
import {IMucThuTuyenSinhSelectRequest} from "../../../model/request/chung-tu-tuyen-sinh/IMucThuTuyenSinhSelectRequest";
import {IMucThuTuyenSinhViewModel} from "../../../model/respone/chung-tu-tuyen-sinh/IMucThuTuyenSinhViewModel";
import {ITsHoSoThiSinh} from "../../../model/respone/category/ITsHoSoThiSinh";
import {mucThuTuyenSinhThiSinhApi} from "../../../api/chung-tu/mucThuTuyenSinhApi";
import {
    eImportTuyenSinhActionIds,
    IImportTuyenSinhActionTypes,
} from "../../action-types/thu-phi-tuyen-sinh/IImportTuyenSinhActionTypes";
import {IDataBIDV} from "../../../model/respone/import/IDataBIDV";
import {IProcessRequest} from "../../../model/request/IProcessRequest";

export function* thuPhiTuyenSinhSaga(): any {
    yield takeLatest(eThuPhiTuyenSinhActionIds.LOAD_MUC_THU_START, loadWorker);
    yield takeLatest(
        eThuPhiTuyenSinhActionIds.ADD_NEW_TAB_BY_ID,
        addNewTabWorker
    );
    yield takeLatest(
        eThuPhiTuyenSinhActionIds.CREATE_BIENLAITHU_START,
        createBienLaiWorker
    );
    yield takeLatest(
        eThuPhiTuyenSinhActionIds.LOAD_EDIT_BIENLAI_START,
        loadEditBienLaiWorker
    );
    yield takeLatest(
        eThuPhiTuyenSinhActionIds.UPDATE_BIENLAITHU_START,
        updateBienLaiWorker
    );
    yield takeLatest(
        eThuPhiTuyenSinhActionIds.PREVIEW_BIENLAITHU_START,
        previewBienLaiWorker
    );
    yield takeLatest(eImportTuyenSinhActionIds.IMPORT_START, importWorker);
    yield takeLatest(eImportTuyenSinhActionIds.SAVE_START, saveImportWorker);
}

function* loadEditBienLaiWorker(action: IThuPhiTuyenSinhActionTypes): any {
    const {id_bien_lai, request} = action.payload as {
        id_bien_lai: number;
        request: IMucThuTuyenSinhSelectRequest;
    };
    const resMuc: IBaseRespone = yield call(
        mucThuTuyenSinhThiSinhApi.SelectBySinhVien,
        request
    );
    if (resMuc.is_success) {
        yield put(
            rootActions.thuPhi.thuPhiTuyenSinh.LOAD_MUC_THU_SUCCESS({
                request,
                data: resMuc.data,
            })
        );
    }
    const resBl: IBaseRespone = yield call(
        bienLaiThuApi.SelectByIDBienLai,
        id_bien_lai
    );
    if (resBl.is_success) {
        yield put(
            rootActions.thuPhi.thuPhiTuyenSinh.LOAD_EDIT_BIENLAI_SUCCESS({
                request,
                data: resBl.data,
            })
        );
    } else {
        yield put(
            rootActions.thuPhi.thuPhiTuyenSinh.LOAD_EDIT_BIENLAI_ERROR({
                request,
                data: resBl.message ?? "Có lỗi",
            })
        );
    }
}

function* updateBienLaiWorker(action: IThuPhiTuyenSinhActionTypes): any {
    const request = action.payload as IBienLaiThuUpdateRequest;
    const res: IBaseRespone = yield call(bienLaiThuApi.Update, request);
    if (res.is_success) {
        const data: number = res.data;
        yield put(
            rootActions.thuPhi.thuPhiTuyenSinh.UPDATE_BIENLAITHU_SUCCESS({
                request: {
                    ...request,
                    nam_tuyen_sinh: request.nam_tuyen_sinh ?? 0,
                    id_thi_sinh: request.id_thi_sinh ?? 0,
                },
                data,
            })
        );
        yield put(rootActions.bienLai.bienLaiViewChiTiet.LOAD_START(data));
        yield put(
            rootActions.bienLai.bienLaiViewTuyenSinh.LOAD_START({
                nam_tuyen_sinh: request.nam_tuyen_sinh ?? 0,
                id_thi_sinh: request.id_thi_sinh ?? 0,
            })
        );
    } else {
        yield put(
            rootActions.thuPhi.thuPhiTuyenSinh.UPDATE_BIENLAITHU_ERROR({
                request: {
                    ...request,
                    nam_tuyen_sinh: request.nam_tuyen_sinh ?? 0,
                    id_thi_sinh: request.id_thi_sinh ?? 0,
                },
                data: res.message ?? "Có lỗi",
            })
        );
    }
}

function* loadWorker(action: IThuPhiTuyenSinhActionTypes): any {
    const request = action.payload as IMucThuTuyenSinhSelectRequest;
    const res: IBaseRespone = yield call(
        mucThuTuyenSinhThiSinhApi.SelectBySinhVien,
        request
    );
    if (res.is_success) {
        const data: IMucThuTuyenSinhViewModel[] = res.data;
        yield put(
            rootActions.thuPhi.thuPhiTuyenSinh.LOAD_MUC_THU_SUCCESS({
                request: request,
                data,
            })
        );
    } else {
        yield put(
            rootActions.thuPhi.thuPhiTuyenSinh.LOAD_MUC_THU_ERROR({
                request: request,
                data: res.message ?? "Có lỗi",
            })
        );
    }
}

function* addNewTabWorker(action: IThuPhiTuyenSinhActionTypes): any {
    const request = action.payload as number;
    const res: IBaseRespone = yield call(thiSinhApi.SelectById, request);
    if (res.is_success) {
        const data: ITsHoSoThiSinh = res.data;
        yield put(rootActions.thuPhi.thuPhiTuyenSinh.ADD_NEW_TAB(data));
    } else {
        yield put(
            rootActions.thuPhi.thuPhiTuyenSinh.ADD_NEW_TAB_BY_ID_ERROR(
                res.message ?? "Có lỗi"
            )
        );
    }
}

function* createBienLaiWorker(action: IThuPhiTuyenSinhActionTypes): any {
    const request = action.payload as IBienLaiThuCreateRequest;
    const res: IBaseRespone = yield call(bienLaiThuApi.Create, request);
    if (res.is_success) {
        const data: number = res.data;
        yield put(
            rootActions.thuPhi.thuPhiTuyenSinh.CREATE_BIENLAITHU_SUCCESS({
                request: {
                    ...request,
                    nam_tuyen_sinh: request.nam_tuyen_sinh ?? 0,
                    id_thi_sinh: request.id_thi_sinh ?? 0,
                },
                data,
            })
        );
        yield put(
            rootActions.bienLai.bienLaiViewTuyenSinh.LOAD_START({
                nam_tuyen_sinh: request.nam_tuyen_sinh ?? 0,
                id_thi_sinh: request.id_thi_sinh ?? 0,
            })
        );
    } else {
        yield put(
            rootActions.thuPhi.thuPhiTuyenSinh.CREATE_BIENLAITHU_ERROR({
                request: {
                    ...request,
                    nam_tuyen_sinh: request.nam_tuyen_sinh ?? 0,
                    id_thi_sinh: request.id_thi_sinh ?? 0,
                },
                data: res.message ?? "Có lỗi",
            })
        );
    }
}

function* previewBienLaiWorker(action: IThuPhiTuyenSinhActionTypes): any {
    const request = action.payload as IBienLaiThuCreateRequest;
    const res: IBaseRespone = yield call(bienLaiThuApi.Preview, request);
    if (res.is_success) {
        const data: string = res.data;
        yield put(
            rootActions.thuPhi.thuPhiTuyenSinh.PREVIEW_BIENLAITHU_SUCCESS({
                request: {
                    ...request,
                    nam_tuyen_sinh: request.nam_tuyen_sinh ?? 0,
                    id_thi_sinh: request.id_thi_sinh ?? 0,
                },
                data,
            })
        );
    } else {
        yield put(
            rootActions.thuPhi.thuPhiTuyenSinh.PREVIEW_BIENLAITHU_ERROR({
                request: {
                    ...request,
                    nam_tuyen_sinh: request.nam_tuyen_sinh ?? 0,
                    id_thi_sinh: request.id_thi_sinh ?? 0,
                },
                data: res.message ?? "Có lỗi",
            })
        );
    }
}

function* importWorker(action: IImportTuyenSinhActionTypes): any {
    const res: IBaseRespone = yield call(
        mucThuTuyenSinhThiSinhApi.ImportBIDV,
        action.payload as IProcessRequest<FormData>
    );
    if (res.is_success) {
        yield put(rootActions.thuPhi.importTuyenSinh.IMPORT_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.thuPhi.importTuyenSinh.IMPORT_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* saveImportWorker(action: IImportTuyenSinhActionTypes): any {
    const res: IBaseRespone = yield call(
        mucThuTuyenSinhThiSinhApi.SaveImportBIDV,
        action.payload as IProcessRequest<IDataBIDV[]>
    );
    if (res.is_success) {
        yield put(rootActions.thuPhi.importTuyenSinh.SAVE_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.thuPhi.importTuyenSinh.SAVE_ERROR(res.message ?? "Có lỗi")
        );
    }
}
